module.exports = "<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/ui/forms/generic-form-array-group/generic-form-array-entry/generic-form-array-entry.component.html
// module id = ./src/app/core/visbos-core/ui/forms/generic-form-array-group/generic-form-array-entry/generic-form-array-entry.component.html
// module chunks = main